import React from 'react'
import PropTypes from 'prop-types'
import { StaticQuery, graphql } from 'gatsby'
import url from 'url'

import config from '../../../utils/siteConfig'
import ArticleMeta from './ArticleMeta'
import WebsiteMeta from './WebsiteMeta'

/**
 * MetaData will generate all relevant meta data information incl.
 * JSON-LD (schema.org), Open Graph (Facebook) and Twitter properties.
 *
 */
function MetaData({ data, settings, title, description, image, location }) {
  const canonical = url.resolve(config.siteUrl, location.pathname)
  const { ghostPost, ghostTag, ghostPage } = data
  // eslint-disable-next-line no-param-reassign
  settings = settings.allGhostSettings.edges[0].node

  if (ghostPost) {
    return <ArticleMeta data={ghostPost} canonical={canonical} />
  }

  if (ghostTag) {
    return <WebsiteMeta data={ghostTag} canonical={canonical} type="Series" />
  }

  if (ghostPage) {
    return <WebsiteMeta data={ghostPage} canonical={canonical} type="WebSite" />
  }

  // eslint-disable-next-line no-param-reassign, react/prop-types
  title = title || config.siteTitleMeta || settings.title
  // eslint-disable-next-line no-param-reassign
  description =
    // eslint-disable-next-line react/prop-types
    description || config.siteDescriptionMeta || settings.description
  // eslint-disable-next-line no-param-reassign, react/prop-types
  image = image || settings.cover_image || null

  // eslint-disable-next-line no-param-reassign
  image = image ? url.resolve(config.siteUrl, image) : null

  return (
    <WebsiteMeta
      data={{}}
      canonical={canonical}
      title={title}
      description={description}
      image={image}
      type="WebSite"
    />
  )
}

MetaData.propTypes = {
  data: PropTypes.shape({
    // eslint-disable-next-line react/forbid-prop-types
    ghostPost: PropTypes.object,
    // eslint-disable-next-line react/forbid-prop-types
    ghostTag: PropTypes.object,
    // eslint-disable-next-line react/forbid-prop-types
    ghostAuthor: PropTypes.object,
    // eslint-disable-next-line react/forbid-prop-types
    ghostPage: PropTypes.object,
  }),
  settings: PropTypes.shape({
    // eslint-disable-next-line react/forbid-prop-types
    allGhostSettings: PropTypes.object.isRequired,
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  title: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.string,
}

MetaData.defaultProps = {
  data: {},
  title: '',
  description: '',
  image: '',
}

export default function MetaDataQuery(props) {
  return (
    <StaticQuery
      query={graphql`
        query GhostSettingsMetaData {
          allGhostSettings {
            edges {
              node {
                title
                description
              }
            }
          }
        }
      `}
      // eslint-disable-next-line react/jsx-props-no-spreading
      render={(data) => <MetaData settings={data} {...props} />}
    />
  )
}
